import React from "react";
import { useParams } from "react-router-dom";

import bike from "../assets/bike.jpeg";
import bike1 from "../assets/bike1.jpeg";
import bike2 from "../assets/bike2.jpeg";
import bike3 from "../assets/bike3.jpeg";
import bike4 from "../assets/bike4.jpeg";
import bike5 from "../assets/bike5.jpeg";
import bike6 from "../assets/bike6.jpg";

const productData = [
  {
    id: 1,
    name: "MAKI",
    range: "80km",
    speed: "50km/h",
    price: "₹72,999",
    type: "E-Bike",
    image: bike,
    reverseMode: true,
    projectorHeadTailLamps: true,
    usbPort: true,
    sideStand: true,
    antiTheftAlarm: true,
    antiTheftMotorLocking: true,
    remoteKeylessStart: true,
    Motor: "250 Watt BLDC (IP60)",
    Controller: "48V (IP57)",
    BatteryType: "VRLA Battery",
    BatteryRating: "1.5 KWH",
    Charger: "48V 150 WH",
    ChargingTime: "7 - 8 hrs",
    Mileage: "50 - 60 km per charge",
    GroundClearance: "15 Centimeter",
    BrakeType: "Front: Drum, Rear: Drum",
    ClimbingCapacity: "9 Degrees",
    descripation: "Best E-Bike in the Kukatpally",
  },
  {
    id: 2,
    name: "JV",
    range: "100km",
    speed: "55km/h",
    price: "₹84,999",
    type: "e-Bike",
    image: bike1,
    reverseMode: true,
    ledLights: true,
    usbPort: true,
    sideStandWithSensor: true,
    antiTheftAlarm: true,
    antiTheftMotorLocking: true,
    remoteKeylessStart: true,
    vehicleTouchSensor: true,
    motor: "250 Watt BLDC (IP60)",
    controller: "60V (IP57)",
    batteryType: "VRLA Battery",
    batteryRating: "1.92 KWH",
    charger: "60V 240 WH",
    chargingTime: "7 - 8 hrs",
    mileage: "60 - 70 km per charge",
    groundClearance: "18 Centimeter",
    brakeType: "Front: Disc, Rear: Drum",
    climbingCapacity: "9 Degrees",
    descripation: "Best e-Bike in the Kukatpally",
  },
  {
    id: 3,
    name: "RABBITOR",
    range: "70km",
    speed: "45km/h",
    price: "₹68,499",
    type: "E-Bike",
    image: bike2,
    reverseMode: true,
    projectorHeadTailLamps: true,
    usbPort: true,
    alloySideStand: true,
    antiTheftAlarm: true,
    antiTheftMotorLocking: true,
    remoteKeylessStart: true,
    vehicleTouchSensor: true,
    motor: "250 Watt BLDC (IP60)",
    controller: "72V (IP57)",
    batteryType: "VRLA / Lithium Ion Battery",
    batteryRating: "2.3 KWH",
    charger: "72V 200 WH / 72V 360 WH",
    chargingTime: "7 – 8 hrs / 4 – 5 hrs",
    mileage: "80+ km per charge",
    groundClearance: "15 Centimeter",
    brakeType: "Front: Disc, Rear: Drum",
    climbingCapacity: "9 Degrees",
    descripation: "Best eletric Bike in the Kukatpally",
  },
  {
    id: 4,
    name: "E-Bike Thunder Pro",
    range: "90km",
    speed: "60km/h",
    price: "₹89,999",
    type: "E-Bike",
    image: bike3,
    reverseMode: true,
    projectorHeadTailLamps: true,
    usbPort: true,
    alloySideStandWithSensor: true,
    antiTheftAlarm: true,
    antiTheftMotorLocking: true,
    remoteKeylessStart: true,
    vehicleTouchSensor: true,
    motor: "1500 Watt BLDC (IP67)",
    controller: "60V (IP67)",
    batteryType: "VRLA / Lithium Battery",
    batteryRating: "1.8 KWH / 2.3 KWH",
    charger: "60V 230 WH / 60V 240 WH",
    chargingTime: "4–5 hrs",
    mileage: "75–85 km per charge",
    groundClearance: "18 Centimeter",
    brakeType: "Front: Disc brake, Rear: Drum brake",
    tyreSize: "90/100-10 TL",
    climbingCapacity: "9 Degrees",
    descripation: "Best Eletric Bike in the Kukatpally",
  },
  {
    id: 5,
    name: "E-Bike Thunder SSUP",
    range: "90km",
    speed: "60km/h",
    price: "₹89,999",
    type: "E-Bike",
    image: bike4,
    reverseMode: true,
    ledLights: true,
    usbPort: true,
    sideStand: true,
    antiTheftAlarm: true,
    antiTheftMotorLocking: true,
    remoteKeylessStart: true,
    vehicleTouchSensor: true,
    motor: "250 Watt BLDC (IP60)",
    controller: "60V (IP60)",
    batteryType: "Lithium Battery",
    batteryRating: "1.8 KWH",
    charger: "60V 300 WH",
    chargingTime: "6–7 hrs",
    mileage: "60–70 km per charge",
    groundClearance: "15 Centimeter",
    brakeType: "Front: Disc brake, Rear: Disc brake",
    tyreSize: "90/90-12 TL",
    climbingCapacity: "15 Degrees",
    descripation: "Best Zelio Bike in the Kukatpally",
  },
   {
  id: 6,
  name: "NK Electric Scooty",
  range: "75–90 km",
  speed: "45–55 km/h",
  price: "₹68,999 – ₹76,999",
  type: "E-Scooter",
   image: bike5,
  
  reverseMode: true,
  ledLights: true,
  usbPort: true,
  sideStand: true,
  antiTheftAlarm: true,
  antiTheftMotorLocking: true,
  remoteKeylessStart: true,
  vehicleTouchSensor: true,
  motor: "250W BLDC Hub Motor (IP67)",
  controller: "48V Smart Controller",
  batteryType: "Lithium / VRLA (Variant Based)",
  batteryRating: "1.5 KWH – 2.0 KWH",
  charger: "48V High-Efficiency Charger",
  chargingTime: "6–8 hrs",
  mileage: "60–80 km per charge",
  groundClearance: "15 Centimeter",
  brakeType: "Front: Drum brake, Rear: Drum brake",
  tyreSize: "90/90-12 TL",
  climbingCapacity: "9–10 Degrees",
  descripation: "Best NK Scooty in the Kukatpally",
},

{
  id: 7,
  name: "Zelio Electric Scooty",
  range: "60–120 km",
  speed: "45–55 km/h",
  price: "₹57,999 – ₹79,999",
  type: "E-Scooter",
  image: bike6,
  reverseMode: true,
  ledLights: true,
  usbPort: true,
  sideStand: true,
  antiTheftAlarm: true,
  antiTheftMotorLocking: true,
  remoteKeylessStart: true,
  vehicleTouchSensor: true,
  motor: "250W–350W BLDC Hub Motor (IP67)",
  controller: "48V / 60V Intelligent Controller",
  batteryType: "Lithium-Ion / VRLA",
  batteryRating: "1.5 KWH / 2.0 KWH / 2.5 KWH",
  charger: "48V/60V Smart Charger",
  chargingTime: "4–7 hrs",
  mileage: "70–120 km per charge",
  groundClearance: "12–15 Centimeter",
  brakeType: "Front: Drum brake, Rear: Drum brake",
  tyreSize: "90/90-12 TL",
  climbingCapacity: "10–12 Degrees",
  descripation: "Best Zelio",
}
]

const BikeDetails = () => {
  const { id } = useParams();
  const bike = productData.find((bike) => bike.id === parseInt(id));

  if (!bike) {
    return (
      <div className="h-screen flex items-center justify-center">
        <h1 className="text-2xl font-bold">Bike not found</h1>
      </div>
    );
  }

  return (
    <section className="py-16 bg-gray-100">
      <div className="container mx-auto px-4">

        <div className="bg-white rounded-2xl shadow-2xl p-6 md:p-10 flex flex-col md:flex-row gap-12">

          {/* Image */}
          <div className="md:w-1/2 flex justify-center items-center">
            <img
              src={bike.image}
              alt={bike.name}
              className="w-full max-w-xl h-auto rounded-xl shadow-lg transform hover:scale-105 transition duration-300"
            />
          </div>

          {/* Details */}
          <div className="md:w-1/2 overflow-y-auto max-h-[600px] pr-3">
            <h1 className="text-5xl font-extrabold bg-gradient-to-r from-green-600 to-green-800 text-transparent bg-clip-text mb-4">
              {bike.name}
            </h1>

            <p className="text-gray-700 text-lg mb-2">
              <strong>Range:</strong> {bike.range}
            </p>

            <p className="text-gray-700 text-lg mb-2">
              <strong>Top Speed:</strong> {bike.speed}
            </p>

            <p className="text-green-700 text-4xl font-bold mt-4">
              {bike.price}
            </p>

            <p className="mt-3 text-gray-600 italic">⭐ {bike.descripation}</p>

            <hr className="my-6" />

            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              Specifications
            </h2>

            {/* Specs Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8">
              {Object.entries(bike)
                .filter(
                  ([key]) =>
                    ![
                      "id",
                      "name",
                      "image",
                      "price",
                      "range",
                      "speed",
                      "descripation",
                    ].includes(key)
                )
                .map(([key, value]) => {
                  if (!value) return null;

                  const label = key
                    .replace(/([A-Z])/g, " $1")
                    .replace(/^./, (str) => str.toUpperCase());

                  return (
                    <div key={key} className="bg-gray-50 p-3 rounded-lg shadow-sm">
                      <p className="text-gray-500 text-sm font-semibold">
                        {label}
                      </p>
                      <p className="text-gray-800 text-lg font-medium">{value.toString()}</p>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BikeDetails;
